import ContactForm from "./ContactForm";
import { COMPANY } from "@/lib/seo";
import { Link } from "@/lib/router-compat";

interface FinalContactSectionProps {
  title?: string;
  source: string;
}

const FinalContactSection = ({ title = "Ready to Get Started?", source }: FinalContactSectionProps) => (
  <section className="bg-charcoal text-charcoal-foreground">
    <div className="container grid gap-8 py-10 md:py-12 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:items-start">
      <div>
        <p className="font-condensed text-[13px] font-bold uppercase text-primary-light">Start a conversation</p>
        <h2 id="ready-to-get-started" className="mt-2 font-heading text-3xl font-bold text-white">{title}</h2>
        <p className="mt-4 max-w-[48ch] font-body text-[15px] leading-relaxed text-charcoal-foreground/70">
          Our licensed electricians and energy specialists are ready to help. 1-year warranty on all work plus manufacturer's warranties available.
        </p>
        <a href={`tel:${COMPANY.phoneTel}`} className="mt-6 block font-condensed text-[32px] font-bold leading-none text-white hover:text-primary-light">
          {COMPANY.phone}
        </a>
        <Link to="/request-estimate" className="mt-4 inline-block font-condensed text-[13px] font-bold uppercase text-primary-light hover:underline">
          Request an Estimate
        </Link>
      </div>
      <div className="rounded-[4px] border border-border bg-background p-5 text-foreground md:p-7">
        <ContactForm source={source} />
      </div>
    </div>
  </section>
);

export default FinalContactSection;